import React from 'react';
import { Smartphone, MapPin, Search, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorks: React.FC = () => {
    const { t } = useTranslation();
    const isEng = t('common.loading') === 'Loading...';

    const steps = [
        {
            icon: <Smartphone size={32} className="text-orange-500" />,
            title: isEng ? "1. Open the App" : "1. Abra a App",
            description: isEng 
                ? "Log in and see available motorbikes near you on the real-time map." 
                : "Faça login e veja as motas disponíveis perto de si no mapa em tempo real."
        },
        {
            icon: <Search size={32} className="text-blue-500" />,
            title: isEng ? "2. Set Destination" : "2. Escolha o Destino",
            description: isEng 
                ? "Enter where you want to go. View the estimated price before confirming." 
                : "Insira para onde quer ir. Veja o preço estimado antes de confirmar."
        },
        {
            icon: <MapPin size={32} className="text-green-500" />,
            title: isEng ? "3. Confirm Ride" : "3. Confirme o Pedido",
            description: isEng 
                ? "The nearest rider will accept the ride and come to pick you up." 
                : "O motoqueiro mais próximo aceita a corrida e vem ter consigo."
        },
        {
            icon: <CheckCircle size={32} className="text-purple-500" />,
            title: isEng ? "4. Ride Safely" : "4. Viaje Seguro",
            description: isEng 
                ? "Track your journey, share details, and pay digitally without hassle." 
                : "Acompanhe o trajeto, partilhe a viagem e pague digitalmente."
        }
    ];

  return (
    <section id="how-it-works" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {isEng ? "Ordering a MotoRush is easy as 1, 2, 3, 4." : "Pedir uma MotoRush é tão fácil como 1, 2, 3, 4."}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {isEng ? "No complications. Just fast and efficient mobility." : "Sem complicações. Apenas mobilidade rápida e eficiente."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
                <div key={index} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group">
                    <div className="absolute -right-4 -top-4 w-20 h-20 bg-gray-50 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
                    <div className="relative z-10">
                        <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-white group-hover:shadow-inner transition-colors">
                            {step.icon}
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                        <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                    </div>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
